<!-- <div class="content content-center">
	<br>
    <div class="mat-elevation-z4 content-center"
        style="padding: 1em;border-radius: 10px;width: fit-content;background-color: whitesmoke;">
        <span>{{WaitMessage}}</span>
    </div>
</div> -->

<div class="loading-container">
	<div class="loading-card">
		<div class="loading-spinner">
			<span></span>
			<span></span>
			<span></span>
		</div>

		<div class="loading-message">
			<span>{{WaitMessage}}</span>
		</div>
	</div>
</div>